export const LogoMark = ({ className = "", color = "currentColor", accent = "currentColor" }) => (
  <svg viewBox="0 0 64 80" className={className} aria-hidden="true">
    <ellipse cx="32" cy="40" rx="27" ry="36" fill="none" stroke={accent} strokeWidth="1.6" strokeDasharray="12 5" />
    <path d="M43.5 27.5 A13.5 16 0 1 0 45 47.5 L45 41 L36 41" fill="none" stroke={color} strokeWidth="1.3" strokeDasharray="44 3 80" />
    <path d="M40.8 29.8 A10.5 13 0 1 0 42 45 L42 43.5" fill="none" stroke={color} strokeWidth="1.3" strokeDasharray="34 3 60" />
  </svg>
);

export const Logo = ({ dark = false, className = "h-11" }) => (
  <img
    src={dark ? "/images/logo-gioia-light.png" : "/images/logo-gioia-dark.png"}
    alt="GIOIA centro estetico"
    data-testid="brand-logo"
    className={`w-auto block select-none transition-opacity duration-500 ${className}`}
    draggable="false"
  />
);
